import {useEffect} from 'react';

import {EventType, InteractionType} from '@azure/msal-browser';
import {useIsAuthenticated, useMsal} from '@azure/msal-react';
import {oneOfType, node, func} from 'prop-types';

import {scopeBase} from '../authConfig';
import useAuth from '../hooks/providers/useAuth';
import useLoading from '../hooks/providers/useLoading';
import Maintenance from '../pages/Maintenance/Maintenance';

const RequireMaintenanceStatus = ({children}) => {
  const auth = useAuth();
  const {isMaintenanceMode, maintenanceMessage} = useLoading();

  const {instance, inProgress, accounts} = useMsal();
  const isLogged = useIsAuthenticated();

  const localStorageItem = localStorage.getItem('user');
  console.log({localStorageItem: JSON.parse(localStorageItem)});

  useEffect(() => {
    const eventCallback = instance.addEventCallback(async message => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        const {payload} = message;
        auth.setUser({
          ...(auth.user || {}),
          username: payload.account.name,
          tokenAad: payload.accessToken,
          mail: payload.account.username
        });
      }
    });
    return () => {
      if (eventCallback) {
        instance.removeEventCallback(eventCallback);
      }
    };
  }, [instance]);

  useEffect(() => {
    if (isLogged && !auth.user && inProgress === InteractionType.None) {
      const loginRequest = {
        scopes: scopeBase,
        account: accounts[0]
      };

      console.log('Mismatch between MSAL logged state and app logged state. Perform silent login ?');
      instance
        .acquireTokenSilent(loginRequest)
        .then(response => {
          auth.setIsTokenInvalid(false);
          auth.setUser({
            username: accounts[0].name,
            tokenAad: response.accessToken,
            mail: accounts[0].username
          });
        })
        .catch(error => {
          // Refresh access token silently from cached id-token
          // Makes the call to handleredirectcallback
          if (error.errorCode === 'consent_required' || error.errorCode === 'interaction_required' || error.errorCode === 'login_required') {
            instance.acquireTokenRedirect(loginRequest);
          } else if (error.errorCode === '429') {
            // eslint-disable-next-line no-console
            console.error('Our Service Token Server (STS) is overloaded, please try again in sometime');
          } else {
            // eslint-disable-next-line no-console
            console.error(`There was some problem fetching the access token ${error.toString()}`);
          }
        });
    }
  }, [isLogged, auth.user, inProgress]);

  if (isMaintenanceMode) return <Maintenance title="Application en maintenance" subtitle={maintenanceMessage} />;

  return children;
};

RequireMaintenanceStatus.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default RequireMaintenanceStatus;
